import type { ApiRoute, NoBody, NoQueryParams } from "../api"
import type { OfferPorscheCodeVehicleDataPathParams } from "./OfferPorscheCodeVehicleDataPathParams"
import type { OfferVehicleDataView } from "./OfferVehicleDataView"

export const getVehicleDataByPorscheCodeForCsvOfferRoute: ApiRoute<
	OfferPorscheCodeVehicleDataPathParams,
	NoQueryParams,
	NoBody,
	OfferVehicleDataView
> = {
	buildUrl: ({ porscheCode }) => `/offers/vehicle-data/csv/porsche-code/${porscheCode}`,
	method: "get",
	path: "/offers/vehicle-data/csv/porsche-code/:porscheCode",
}
